<input hidden [value]="(selectedItem$ | async)?.getSelectionTitle()" [attr.id]="controlId" [attr.name]="name" />

<!-- Desktop -->
<input
  type="text"
  #content
  class="reactive-form-input reactive-form-html-dropdown"
  autocomplete="off"
  [attr.id]="controlId + '_input'"
  (input)="filterDropdowns()"
  (focus)="onInputFocus()"
  (blur)="onInputBlur($event)"
  (keydown)="handleKeyDown($event)"
  [placeholder]="placeholder"
  [hidden]="isMobile"
  [class.form-error-border]="error"
  [class.placeholder-selected]="!!(selectedItem$ | async)"
  [class.dropdown-open]="showDropdown$ | async"
  [disabled]="disabled"
  [class.disabled]="disabled" />

<div class="dropdown-content" [tabindex]="-1" [hidden]="!(showDropdown$ | async) || isMobile" #dropdownContent>
  <div
    [tabindex]="-1"
    class="dropdown-item clearable"
    *ngIf="clearable && !disabled && (selectedItem$ | async)"
    (click)="resetInput(); closeDropdown()"
    i18n>
    Clear Selection
  </div>
  <div class="dropdown-item selected" *ngIf="selectedItem$ | async" [tabindex]="-1">
    <img class="icon-img" src="assets/icons/dark/Check.svg" />
    {{ (selectedItem$ | async)?.title }}
  </div>
  <hr class="selected-item-divider" *ngIf="selectedItem$ | async" />
  <div
    #dropdownItem
    [tabindex]="-1"
    class="dropdown-item"
    *ngFor="let item of filteredDropdowns$ | async"
    (click)="itemSelected(item)"
    [hidden]="item.value === (selectedItem$ | async)?.value"
    [class.disabled]="item.getSelectionIsDisabled()">
    <img *ngIf="item?.iconSrc" class="icon-img" [src]="item.iconSrc" />
    {{ item.getSelectionTitle() }}
  </div>
  <div class="dropdown-item" *ngIf="!(filteredDropdowns$ | async)?.length" [tabindex]="-1" i18n>No Results</div>
</div>

<!-- Mobile -->
<select
  #select
  [hidden]="!isMobile"
  class="reactive-form-input reactive-form-html-dropdown"
  [disabled]="disabled"
  [class.form-error-border]="error"
  [value]="(selectedItem$ | async)?.getSelectionValue() ?? ''"
  [ngClass]="{ 'placeholder-selected': !(selectedItem$ | async)?.getSelectionValue() }"
  (change)="onSelectChanged($event)">
  <option value="" disabled>
    {{ placeholder }}
  </option>
  <option *ngFor="let drop of dropdowns" [value]="drop.getSelectionValue()" [disabled]="drop.getSelectionIsDisabled()">
    {{ drop.getSelectionTitle() }}
  </option>
</select>
